var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomePageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 933,
    height: 548,
    viewBox: "0 0 933 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1333_20946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.101 442.28C617.841 435.694 607.31 411.122 587.491 401.663C551.285 384.376 511.833 414.695 522.256 454.97C532.817 495.602 579.725 505.574 575.547 539.947C573.993 553.04 573.481 565.886 576.183 578.436H664.313",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.789 319.063C627.316 322.775 613.088 336.847 609.065 360.363C601.936 401.741 648.812 425.816 634.569 457.377C616.629 497.031 614.921 540.211 664.36 578.436L748.327 579.305V362.973C748.327 362.973 737.92 365.411 719.282 359.726C719.282 359.726 719.841 372.447 715.88 378.365C711.92 384.283 701.544 387.405 687.922 385.712L690.671 378.909C688.092 380.155 685.139 380.394 682.393 379.577L696.154 352.659C696.154 352.659 673.493 343.511 657.2 329.578L644.789 319.063Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.463 205.243L536.934 223.54L521.883 248.904C521.883 248.904 537.664 254.884 541.112 232.067L547.107 230.125L561.086 239.119L507.935 321.75L462.596 292.596C462.596 292.596 471.061 289.055 468.809 274.315C468.809 274.315 499.516 275.216 496.767 255.459L471.589 262.386L508.463 205.243Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.113 214.22C580.113 214.22 575.64 229.38 575.64 252.135C575.64 274.889 583.111 294.802 592.912 294.802C602.712 294.802 610.183 276.008 610.183 250.022C610.183 224.037 604.483 216.768 604.483 216.768L580.113 214.22Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.944 354.01C445.959 362.585 451.835 370.625 458.48 378.008C469.12 389.641 487.852 402.098 494.795 393.897C501.737 385.696 490.337 361.683 476.265 345.747C468.02 336.317 458.165 328.428 447.157 322.449L440.944 354.01Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.806 148.441C734.27 146.888 729.72 144.776 726.38 138.765C716.315 120.328 729.487 100.773 733.696 74.9275C736.192 58.8884 736.035 42.5481 733.23 26.5601C733.23 26.5601 732.034 43.1485 726.784 47.0937C721.534 51.0389 714.358 49.4701 706.406 46.5656C697.086 43.133 686.307 39.5761 672.825 44.1736C672.825 44.1736 688.714 1.16492 729.828 1.16492C745.966 1.16492 756.885 7.78165 767.012 18.9183C778.009 31.0179 786.039 37.122 799.63 39.1878C813.221 41.2536 830.368 52.0174 835.339 68.3418C840.309 84.6662 848.153 90.8946 866.776 100.276C885.399 109.658 891.627 127.721 891.627 145.087C891.627 162.452 882.883 191.466 845.714 189.353C810.782 187.381 796.461 160.774 799.785 138.656L738.806 100.292V148.441Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.513 382.605C180.407 376.967 177.658 372.354 177.658 372.354C177.658 372.354 175.11 379.996 166.35 374.42C157.59 368.844 152.806 355.455 158.864 351.323C164.921 347.192 173.837 359.09 173.837 359.09C171.176 347.342 165.006 336.681 156.145 328.522C156.145 328.522 168.214 329.594 174.225 326.161C188.685 317.914 182.597 307.274 203.208 306.808C223.819 306.342 228.976 285.374 216.519 272.28C204.062 259.186 189.478 266.704 184.678 272.28C180.324 277.705 174.417 281.671 167.748 283.649C160.665 285.808 146.484 285.374 141.126 294.522C138.828 298.413 137.669 302.871 137.782 307.389C137.895 311.906 139.274 316.301 141.763 320.073C146.065 326.736 145.848 332.747 142.198 337.686C138.547 342.625 134.043 348.201 133.826 354.212C133.608 360.223 137.041 364.293 144.294 365.582C151.548 366.871 153.365 371.795 154.654 374.342C155.944 376.889 157.652 387.917 168.804 389.874C173.604 390.713 181.09 388.539 182.783 382.854L183.513 382.605Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.013 198.579C308.919 198.579 329.92 177.578 329.92 151.672C329.92 125.766 308.919 104.765 283.013 104.765C257.106 104.765 236.105 125.766 236.105 151.672C236.105 177.578 257.106 198.579 283.013 198.579Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.511 46.5967C683.511 46.5967 679.364 65.5615 686.618 90.3199C693.607 114.395 708.145 123.419 720.074 121.742",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.171 68.3573L699.276 86.266H705.52",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.462 63.853C720.462 63.853 716.439 70.5474 711.36 63.853",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.455 65.5771C695.455 65.5771 691.821 72.054 687.689 65.1732",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.327 545.507L651.22 359.09",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.057 405.577L694.244 441.69",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.802 498.429L655.149 502.188",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.06 504.021L563.773 437.838",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.182 486.019L575.64 485.04",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.21 458.418L583.825 432.79",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.768 309.355L279.021 253.424",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.763 298.467L281.459 290.934",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.133 274.983L260.957 253.719",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.87 184.088L894.982 198.642",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.594 378.753C688.031 380.063 685.054 380.303 682.315 379.421L698.298 348.17L738.806 351.929V100.307L799.754 138.672",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.771 348.574L687.845 385.556C687.845 385.556 702.569 388.166 712.401 381.704C717.356 378.458 719.282 372.385 719.282 360.658",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.767 349.133L697.226 386.069",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.057 349.724L707.633 384.065",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.36 578.28C647.942 566.575 635.231 550.402 627.735 531.684",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.327 322.511V391.101",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.806 322.511H840.48L756.249 126.308",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.097 133.189L682.315 205.227H530.923L526.341 212.745",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.912 205.227C602.448 205.227 610.183 225.279 610.183 250.022",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.551 318.908C429.73 330.899 436.657 351.65 452.19 370.894",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.483 216.768L556.489 211.735C556.489 211.735 559.331 228.572 541.174 232.067C541.174 232.067 538.564 254.154 521.945 248.904L541.842 215.23",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.383 322.511C810.689 329.268 816.312 335.263 823.596 342.998",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.282 151.672C713.559 168.254 712.395 186.069 715.911 203.255C719.018 217.234 723.196 228.106 738.806 248.298",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.912 294.802C642.164 294.802 696.605 282.578 719.282 224.41",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.282 359.556C742.087 364.46 765.734 363.834 788.248 357.729C810.761 351.624 831.486 340.219 848.69 324.466C865.893 308.713 879.076 289.07 887.135 267.18C895.194 245.291 897.895 221.789 895.013 198.642C894.108 191.253 892.628 183.946 890.587 176.788",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.341 485.522C538.86 486.733 538.394 487.945 537.943 489.141",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.458 496.441C531.412 509.685 528.987 523.37 528.235 537.198C522.908 619.782 575.64 683.2 668.585 687.052C751.263 690.47 828.007 627.269 818.393 528.065C812.18 455.622 814.96 421.063 847.904 389.455C875.35 363.05 909.225 363.703 924.105 365.566",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.97 4.97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.895 366.126C930.334 366.545 931.685 366.887 931.685 366.887",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.465 447.934C437.745 479.2 427.447 517.829 390.216 537.819",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.599 252.771H454.131C454.131 252.771 453.634 255.194 430.755 327.777C407.876 400.359 337.717 459.272 248.593 438.816C159.469 418.36 132.676 410.579 132.676 410.579L1.16492 513.822",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.795 393.897C494.795 393.897 412.722 507.5 250.535 462.69V579.181",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.328 439.857L62.7502 562.764",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.834 370.677C574.12 370.677 586.512 358.285 586.512 342.998C586.512 327.712 574.12 315.32 558.834 315.32C543.548 315.32 531.156 327.712 531.156 342.998C531.156 358.285 543.548 370.677 558.834 370.677Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.455 304.618C379.393 304.618 388.259 295.752 388.259 284.814C388.259 273.877 379.393 265.011 368.455 265.011C357.518 265.011 348.652 273.877 348.652 284.814C348.652 295.752 357.518 304.618 368.455 304.618Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0883 436.191C95.0883 436.191 42.3719 409.787 42.3719 332.747C42.3719 280.372 73.4364 243.033 120.328 224.41C175.079 202.664 221.707 216.737 255.567 191.373C289.427 166.008 288.449 122.549 276.846 101.115C265.384 79.9754 238.855 60.0321 204.326 68.3418C172.874 75.906 154.002 100.338 151.253 126.293",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.535 345.825V224.41",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.937 266.176L496.876 255.459C496.876 255.459 502.343 273.429 468.918 274.315C468.918 274.315 473.578 295.097 452.64 294.802L440.96 354.01",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.851 419.929L177.005 446.194L196.654 426.686L203.084 451.739L225.497 433.473",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.654 426.686C196.073 434.718 193.442 442.467 189.012 449.192C181.851 459.35 179.304 469.151 182.317 485.04C185.331 500.93 184.616 516.431 172.377 529.571C160.137 542.712 156.456 555.572 159.221 579.15C161.986 602.728 157.373 615.946 143.518 630.236C129.663 644.525 127.83 659.529 127.986 667.839",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.051 171.352C614.051 171.352 665.509 166.474 667.358 111.009C669.051 60.5757 623.961 46.5967 608.677 46.5967C569.287 46.5967 542.075 74.3372 539.652 109.005C537.229 143.673 561.971 157.901 581.806 139.945C601.641 121.99 594.62 82.4761 589.665 63.8375C584.85 45.8356 570.312 15.905 535.085 2.34537",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.734 364.79L227.376 361.202L214.376 339.566",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.345 339.566C214.345 339.566 216.814 330.821 225.932 334.766",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.264 343.014C204.264 343.014 194.945 335.745 189.478 350.423",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.569 428.798C208.004 421.965 208.823 414.66 207.961 407.457",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.837 424.325C189.01 409.592 187.208 394.545 181.618 380.741V380.741C187.505 391.614 199.853 409.367 218.135 409.367C244.539 409.367 249.37 366.825 218.135 306.855",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.53 284.861L519.972 270.773L509.783 212.745",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.493 579.15C270.091 587.132 260.694 593.997 250.535 599.575C228.346 611.946 203.403 618.542 177.999 618.757C144.275 618.753 111.583 607.128 85.4283 585.839C59.2733 564.55 41.2536 534.898 34.4039 501.877",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.217 469.353C193.139 469.353 194.696 467.795 194.696 465.874C194.696 463.952 193.139 462.394 191.217 462.394C189.296 462.394 187.738 463.952 187.738 465.874C187.738 467.795 189.296 469.353 191.217 469.353Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.963 378.862C225.963 378.862 212.108 381.409 206.951 377.433",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.008 346.539C201.475 346.539 202.664 345.35 202.664 343.883C202.664 342.417 201.475 341.227 200.008 341.227C198.542 341.227 197.352 342.417 197.352 343.883C197.352 345.35 198.542 346.539 200.008 346.539Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.691 339.301C223.158 339.301 224.347 338.112 224.347 336.645C224.347 335.179 223.158 333.989 221.691 333.989C220.225 333.989 219.035 335.179 219.035 336.645C219.035 338.112 220.225 339.301 221.691 339.301Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.398 97.4802C702.398 97.4802 712.463 98.1947 715.911 95.3213",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.876 329.407C543.876 329.407 566.491 370.677 550.99 418.78C544.467 438.972 516.602 498.429 426.111 486.019C394.519 481.685 366.561 462.084 353.793 435.244C336.583 398.868 350.065 366.436 376.827 364.79C386.592 364.395 396.201 367.337 404.071 373.131",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.236 224.363C463.182 224.363 510.156 177.389 510.156 119.443C510.156 61.497 463.182 14.5226 405.236 14.5226C347.29 14.5226 300.316 61.497 300.316 119.443C300.316 177.389 347.29 224.363 405.236 224.363Z",
    stroke: "#EBEAF4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1333_20946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 932.85,
    height: 688.342,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageIcon);
export default __webpack_public_path__ + "static/media/HomePageIcon.74b25a50813d5a9e24254dee6b82bd2b.svg";
export { ForwardRef as ReactComponent };